import { createContext } from "react";

export const ErrorBoundaryContext = createContext();
